import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { AuthPanel } from '../components/auth';

/**
 * Página /login. No implementa el formulario: monta el mismo AuthPanel que
 * usa el modal del navbar, así que ofrece exactamente lo mismo — correo,
 * contraseña y acceso con Google. Aquí sólo vive lo propio de ser una
 * página: a dónde volver después de entrar.
 */
const LoginPage = () => {
  const [mode, setMode] = useState('login');
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Dos formas de llegar aquí con un destino de vuelta:
  //  - state.from  → navegaciones internas (perfil, pedidos, mis pagos)
  //  - ?redirect=  → redirecciones duras desde los servicios al expirar la
  //                  sesión (paymentService, adminService, erpService)
  const redirectParam = searchParams.get('redirect');
  const from = location.state?.from;
  const redirectTo =
    redirectParam ||
    (from ? `${from.pathname}${from.search || ''}${from.hash || ''}` : '/');

  const sessionExpired = searchParams.get('reason') === 'session_expired';

  // Si ya hay sesión (o si el login se resuelve), no tiene sentido quedarse
  // en esta página.
  useEffect(() => {
    if (isAuthenticated) {
      navigate(redirectTo, { replace: true });
    }
  }, [isAuthenticated, redirectTo, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-df-bg py-12 px-4">
      <div className="w-full max-w-md bg-df-surface border border-df-border rounded-lg shadow-lg overflow-hidden">
        <div className="p-6 pb-4 border-b border-df-border">
          <h1 className="text-2xl font-bold text-df-text text-center">
            {mode === 'login' ? 'Iniciar Sesión' : 'Crear Cuenta'}
          </h1>
          {sessionExpired && (
            <div className="mt-4 bg-df-warning/10 border border-df-warning rounded-md p-3">
              <p className="text-sm text-df-warning">
                Tu sesión expiró. Vuelve a iniciar sesión para continuar.
              </p>
            </div>
          )}
        </div>

        <AuthPanel
          mode={mode}
          onModeChange={setMode}
          onSuccess={() => navigate(redirectTo, { replace: true })}
        />
      </div>
    </div>
  );
};

export default LoginPage;
